// Stripe Payment Element options for the CRM's "Checkout for customer".
//
// That checkout always runs in a STAFF member's browser. Stripe's wallets
// follow the browser, not the customer: on 2026-10-24 the rep checkout for a
// customer offered Casey's own Link-saved Amex, one click from charging the
// rep instead of the customer. The customer site hides Link on shared browsers
// (squish-frontend src/lib/sharedBrowser.js); here every browser is the rep's,
// so no wallet is ever offered. The customer's own saved cards still show,
// through the customer session the backend mints.
//
// Lives outside the component so it runs under `node --test`.
export const REP_PAYMENT_ELEMENT_OPTIONS = Object.freeze({
  layout: 'tabs',
  wallets: Object.freeze({ link: 'never', applePay: 'never', googlePay: 'never' }),
});
